import React from "react";
import Spinner from '../components/Shared/Spinner';

const SettingTable = (props) => {

  const data = props.data.length > 0 ? props.data : [];
  const editSetting = (item) => {
    props.getData(item, "edit");
  };

  const deleteSetting = (item) => {
    props.getData(item, "delete");
  };

  return (
    <>
      <div className="table-responsive card">
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
          <thead>
            <tr>
              <th>Atributo</th>
              <th>Valor</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            { data.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.attr}</td>
                  <td>{item.val}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-icon btn-sm"
                      title="Edit"
                      onClick={() => editSetting(item)}
                    >
                      <i className="fa fa-edit"></i>
                    </button>
                    <button
                      onClick={() => deleteSetting(item)}
                      type="button"
                      className="btn btn-icon btn-sm js-sweetalert"
                      title="Delete"
                      data-type="confirm"
                    >
                      <i className="fa fa-trash-o text-danger"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        { props.isLoading && <Spinner />}
      </div>
    </>
  );
};

export default SettingTable;
